import React, { useState, useCallback } from 'react';
// import { StaticImage } from 'gatsby-plugin-image';

import Select from 'react-select';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import TabHeaderBlock from '../components/TabHeaderBlock';
import {
  Dropdown,
  PeopleImages,
  SelectWithIcon,
  VerticalPriceBox,
} from '../styles/elements';
import { PopupBlock } from '../styles/PopupBlock';
import { WhiteBlock } from '../styles/WhiteBlock';

const currency = [
  { value: 'USD', label: 'USD' },
  { value: 'INR', label: 'INR' },
];

const views = {
  monthly: 0,
  yearly: 1,
};

const PlanAndBilling = () => {
  const [currentTab, setCurrentTab] = useState(views.monthly);

  const toggleTab = useCallback((tab) => () => setCurrentTab(tab), []);

  const renderPrice = useCallback(
    (monthlyPrice, yearlyPrice) => (
      <p className="price">
        {views.monthly === currentTab ? monthlyPrice : yearlyPrice}
        {/* eslint-disable-next-line */}
        <span>/{views.monthly === currentTab ? 'mo' : 'year'}</span>
      </p>
    ),
    [currentTab],
  );

  const [popup, setPopup] = useState(false);
  const popupClick = useCallback((value) => (e) => {
    if (e) e.preventDefault();
    setPopup((state) => (state === value ? null : value));
  });

  return (
    <Layout>
      <SEO title="Home" />
      <div className="db-area-main">
        <div className="db-container">
          <a href="#!" className="db-back-link button-chevron-left">
            <img src="/img/chevron-left.svg" alt="chevron" /> Back to the
            dashboard
          </a>

          <h1 className="db-heading">
            Dribbble Workspace{' '}
            <img
              src="/img/chevron-down.svg"
              alt="chevron"
              style={{ width: 23, opacity: 0.4 }}
            />
          </h1>

          <TabHeaderBlock />
          <div className="single-db-block">
            <div className="db-tab-content-block">
              <div className="flex-row">
                <div className="col col-3">
                  <WhiteBlock className="equal-height position-relative">
                    <div className="white-block-body-small">
                      <div className="flex-row no-margin">
                        <div className="flex-1">
                          <h2 className="small-box-heading">
                            Makestories Lite
                          </h2>
                          <p className="darkgrey">
                            Buy pro plan for more features
                          </p>
                        </div>
                        <Dropdown>
                          <span
                            style={{ opacity: 0.3 }}
                            className="dropdown-dots">
                            <span></span>
                          </span>

                          <ul className="dropdown-menu">
                            <li>
                              <a href="#!">Edit Plan</a>
                            </li>
                            <li>
                              <a href="#!">Cancel Plan</a>
                            </li>
                          </ul>
                        </Dropdown>
                      </div>
                      <div className="grey-bg pad-15 plan-due-block">
                        <div className="flex-row no-margin align-items-center">
                          <div className="flex-1">
                            <p>Due in</p>
                            <h4>June 14</h4>
                          </div>
                          <div className="flex-1">
                            <p>Amount</p>
                            <h4>$14.45</h4>
                          </div>
                          <div className="flex-1 text-center">
                            <a href="#!" className="green">
                              Renew
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="text-right">
                        <a
                          href="#!"
                          onClick={popupClick(0)}
                          className="button light-blue-button">
                          Upgrade
                        </a>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
                <div className="col col-3">
                  <WhiteBlock className="equal-height position-relative">
                    <div className="white-block-body-small">
                      <h3 className="small-heading">No.of Users</h3>
                      <div className="grey-bg pad-15 user-numbers-block">
                        <p>
                          20/ <span style={{ opacity: 0.6 }}>26</span>
                        </p>

                        <PeopleImages>
                          <div className="single-person">
                            <span className="perosn-photo">
                              <img src="/img/person-1.jpg" alt="" />
                            </span>
                            <span className="person-name">Lorem Ipsum</span>
                          </div>
                          <div className="single-person">
                            <span className="perosn-photo">
                              <img src="/img/person-2.jpg" alt="" />
                            </span>
                            <span className="person-name">Lorem Ipsum</span>
                          </div>
                          <div className="single-person">
                            <span className="perosn-photo">
                              <img src="/img/person-3.jpg" alt="" />
                            </span>
                            <span className="person-name">Lorem Ipsum</span>
                          </div>

                          <span className="total-persons">+17</span>
                        </PeopleImages>
                      </div>
                      <div className="text-right">
                        <a
                          href="#!"
                          className="blue-link weight-600 bottom-side-link">
                          Add
                        </a>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
                <div className="col col-3">
                  <WhiteBlock className="equal-height position-relative">
                    <div className="white-block-body-small">
                      <div className="flex-row no-margin justify-space-between">
                        <h3 className="small-heading">Connected Domains</h3>
                        <a href="#!" className="blue-link weight-600">
                          View All (6)
                        </a>
                      </div>
                      <div className="flex-row no-margin justify-space-between mb-30 align-items-center">
                        <a href="#!" className="blue-link">
                          <img src="/img/link-2.svg" alt="link" />{' '}
                          www.makestories.io
                        </a>
                        <div className="text-right">
                          <label className="switch switch-green">
                            <input type="checkbox" />
                            <span className="slider" />
                          </label>
                        </div>
                      </div>
                      <p>Bandwidth</p>
                      <div className="flex-row no-margin justify-space-between align-items-center">
                        <img src="/img/bandwidth-graph.png" alt="" />
                        <div className="text-right">
                          <a
                            href="#!"
                            className="blue-link weight-600 bottom-side-link">
                            Add
                          </a>
                        </div>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
                <div className="col col-3">
                  <WhiteBlock className="equal-height position-relative">
                    <div className="white-block-body-small">
                      <h3 className="small-heading">Payment</h3>

                      <div className="flex-row no-margin justify-space-between payment-method-block">
                        <div className="card-info">
                          <span>
                            <img src="/img/mastercard.svg" alt="mastercard" />
                          </span>
                          <p>
                            <span className="dot" />
                            <span className="dot" />
                            <span className="dot" />
                            <span className="dot" />
                            7575
                          </p>
                        </div>
                        <p className="no-margin" style={{ opacity: 0.4 }}>
                          Primary
                        </p>
                      </div>
                      <div className="flex-row no-margin justify-space-between payment-method-block">
                        <div className="card-info">
                          <span>
                            <img src="/img/visa.png" alt="visa" />
                          </span>
                          <p>
                            <span className="dot" />
                            <span className="dot" />
                            <span className="dot" />
                            <span className="dot" /> 2445
                          </p>
                        </div>
                        <p className="no-margin" style={{ opacity: 0.4 }}>
                          Primary
                        </p>
                      </div>
                      <div className="text-right">
                        <a
                          href="#!"
                          className="blue-link weight-600 bottom-side-link">
                          Add
                        </a>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
              </div>
              <p style={{ marginTop: 20 }}>
                Questions? Check out our{' '}
                <a href="#!" className="blue-link">
                  Billing FAQ
                </a>
                . Something not right?{' '}
                <a href="#!" className="blue-link">
                  Contact us!
                </a>{' '}
              </p>
            </div>
          </div>
          <div className="single-db-block">
            <h2 className="db-heading">Pricing Plans For Workspaces</h2>
            <div className="flex-row">
              <div className="col col-9">
                <div className="pay-tabs mb-30">
                  <button
                    type="button"
                    className={currentTab === views.monthly ? 'active' : ''}
                    onClick={toggleTab(views.monthly)}>
                    Pay Monthly
                  </button>
                  <button
                    type="button"
                    className={currentTab === views.yearly ? 'active' : ''}
                    onClick={toggleTab(views.yearly)}>
                    Pay Yearly
                  </button>
                </div>
              </div>
              <div className="col col-3">
                <Select
                  defaultValue={currency[0]}
                  className="currency-select"
                  options={currency}
                />
              </div>
            </div>

            <div className="workspace-pricing-main">
              <div className="flex-row">
                <div className="col col-6">
                  <WhiteBlock>
                    <div
                      className="flex-row no-margin align-items-center"
                      style={{ padding: 30 }}>
                      <div className="workspace-price-block">
                        <h3>Teams</h3>
                        {renderPrice('$149', '$1200')}

                        <p style={{ opacity: 0.3 }}>PER MONTH BILLED MONTHLY</p>
                        <p>Starts at 5 users</p>

                        <a href="#!" className="button">
                          Upgrade Plan
                        </a>
                      </div>
                      <div className="workspace-price-features">
                        <h3 className="small-heading">What’s included</h3>

                        <ul className="check-list">
                          <li>Unlimited Stories</li>
                          <li>Featured MS Editor</li>
                          <li>Page Attachment</li>
                          <li>Google analytics integration</li>
                          <li>Story Sharing</li>
                        </ul>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
                <div className="col col-6">
                  <WhiteBlock>
                    <div
                      className="flex-row no-margin align-items-center"
                      style={{ padding: 30 }}>
                      <div className="workspace-price-block">
                        <h3>Enterprise</h3>
                        <p className="price">Let&apos;s Chat</p>

                        <p style={{ opacity: 0.3 }}>CUSTOM PRICING</p>
                        <p>Everything in Teams &amp; more</p>

                        <a href="#!" className="button light-blue-button">
                          Contact us
                        </a>
                      </div>
                      <div className="workspace-price-features">
                        <h3 className="small-heading">What’s included</h3>

                        <ul className="check-list">
                          <li>Unlimited Stories</li>
                          <li>Featured MS Editor</li>
                          <li>Page Attachment</li>
                          <li>Google analytics integration</li>
                          <li>Story Sharing</li>
                        </ul>
                      </div>
                    </div>
                  </WhiteBlock>
                </div>
              </div>
            </div>
          </div>

          <div className="single-db-block">
            <h2 className="db-heading">Pricing Plans For Workspaces</h2>

            <div className="flex-row">
              <div className="col col-4">
                <WhiteBlock className="equal-height ">
                  <VerticalPriceBox>
                    <p className="plan-name">Starter</p>
                    <h3 className="price">FREE</h3>
                    <p style={{ opacity: 0.4 }}>NEW ACCOUNTS START HERE</p>
                    <p>Free forever when you host with MakeSuites.</p>

                    <a
                      href="#!"
                      className="button light-blue-button button-block">
                      Current Plan
                    </a>

                    <div className="plan-feature-list">
                      <ul className="check-list">
                        <li>Unlimited Stories</li>
                        <li>Basic Editor Feature</li>
                        <li>Templates</li>
                        <li>Stock Library</li>
                        <li>Stock Library</li>
                        <li>1 month story analytics</li>
                      </ul>
                    </div>
                  </VerticalPriceBox>
                </WhiteBlock>
              </div>
              <div className="col col-4">
                <WhiteBlock className="equal-height center-plan">
                  <VerticalPriceBox>
                    <p className="plan-name">MakeStories Lite</p>
                    <h3 className="price">
                      $34.99<span>/mo</span>
                    </h3>
                    <p style={{ opacity: 0.4 }}>PER MONTH BILLED MONTHLY</p>
                    <p>Light plan let’s you to do this.</p>

                    <a href="#!" className="button button-block">
                      Upgrade Plan
                    </a>

                    <div className="plan-feature-list">
                      <ul className="check-list">
                        <li>Unlimited Stories</li>
                        <li>Basic Editor Feature</li>
                        <li>Templates</li>
                        <li>Stock Library</li>
                        <li>Stock Library</li>
                        <li>1 month story analytics</li>
                        <li>MakeStories Editor Basic Features</li>
                      </ul>
                    </div>
                  </VerticalPriceBox>
                </WhiteBlock>
              </div>
              <div className="col col-4">
                <WhiteBlock className="equal-height">
                  <VerticalPriceBox>
                    <p className="plan-name">MakeStories Pro</p>
                    <h3 className="price">
                      $49.99<span>/mo</span>
                    </h3>
                    <p style={{ opacity: 0.4 }}>PER MONTH BILLED MONTHLY</p>
                    <p>Pro plan let’s you to do this.</p>

                    <a
                      href="#!"
                      className="button button-light-blue button-block">
                      Upgrade plan
                    </a>

                    <div className="plan-feature-list">
                      <ul className="check-list">
                        <li>Unlimited Stories</li>
                        <li>Basic Editor Feature</li>
                        <li>Templates</li>
                        <li>Stock Library</li>
                        <li>Stock Library</li>
                        <li>1 month story analytics</li>
                        <li>1 month story analytics</li>
                      </ul>
                    </div>
                  </VerticalPriceBox>
                </WhiteBlock>
              </div>
            </div>
          </div>

          <div className="single-db-block">
            <h2 className="db-heading">Invoices</h2>

            <WhiteBlock>
              <div
                className="flex-row no-margin align-items-center"
                style={{ padding: 30 }}>
                <div className="col col-7">
                  <div className="search-input">
                    <img src="/img/search.svg" alt="search" />
                    <input type="text" placeholder="Search invoices" />
                  </div>
                </div>
                <div className="col col-5">
                  <div className="flex-row">
                    <div className="col flex-1">
                      <Select className="custom-select" options={currency} />
                    </div>
                    <div className="col flex-1">
                      <Select className="custom-select" options={currency} />
                    </div>
                    <div className="col flex-1">
                      <SelectWithIcon>
                        <img src="/img/calendar.svg" alt="calendar" />
                        <Select className="icon-select" options={currency} />
                      </SelectWithIcon>
                    </div>
                  </div>
                </div>
              </div>
              <table
                className="table inovice-table"
                cellPadding="0"
                cellSpacing="0">
                <thead>
                  <tr>
                    <th>Invoice Id</th>
                    <th>Plan Name</th>
                    <th>Cost</th>
                    <th>Renewal</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>#1029</td>
                    <td>Makestories lite</td>
                    <td>$34.99</td>
                    <td>May 04 2025</td>
                    <td>
                      Completed{' '}
                      <a href="#!">
                        <img src="/img/download-file-icon.svg" alt="" />
                      </a>
                    </td>
                  </tr>
                  <tr>
                    <td>#1029</td>
                    <td>Makestories lite</td>
                    <td>$34.99</td>
                    <td>May 04 2025</td>
                    <td>Completed</td>
                  </tr>
                  <tr>
                    <td>#1029</td>
                    <td>Makestories lite</td>
                    <td>$34.99</td>
                    <td>May 04 2025</td>
                    <td>Completed</td>
                  </tr>
                  <tr>
                    <td>#1029</td>
                    <td>Makestories lite</td>
                    <td>$34.99</td>
                    <td>May 04 2025</td>
                    <td>
                      Completed{' '}
                      <a href="#!" className="blue-link">
                        Pay Now
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </WhiteBlock>
          </div>
        </div>
      </div>
      <PopupBlock className={`${popup === 0 ? 'show-popup' : ''}`}>
        <div className="popup-content">
          <button type="button" onClick={popupClick(0)} className="close-popup">
            <svg
              className="cross-img"
              width="14"
              height="14"
              fill="none"
              viewBox="0 0 20 21">
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="1.636"
                d="M1 1.5l18 18M19 1.5l-18 18"
              />
            </svg>
          </button>
          <div className="text-center upgrade-popup">
            <span className="green-check-circle">
              <img src="/img/green-check.svg" alt="check" />
            </span>

            <h3>Upgrade Successful!</h3>
            <p style={{ maxWidth: 345 }}>
              Congratulation! You will be redirected to your account soon
            </p>
          </div>
        </div>
      </PopupBlock>
    </Layout>
  );
};
export default PlanAndBilling;
